<template>
  <div class="hello">
    <h1 class="hello__title">
      Hi，我是
      <span class="colorful-text">{{ `跟进助手` }}</span>
    </h1>
    <div class="hello__desc">我擅长会话总结，提炼话术，全天在线为你服务，助你高效成单！</div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'

const userName = ref('')
const time = ref('')
onMounted(() => {
  const userInfo = localStorage.getItem('userInfo')
  if (userInfo) {
    const userInfoObj = JSON.parse(userInfo)
    userName.value = userInfoObj.userName
  }
  const now = new Date()
  const hours = now.getHours()
  if (hours >= 0 && hours < 12) {
    time.value = '上午'
  } else if (hours >= 12 && hours < 18) {
    time.value = '下午'
  } else {
    time.value = '晚上'
  }
})
</script>

<style scoped lang="less">
.hello {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 60px;

  .hello__title {
    font-size: 24px;
    font-weight: 600;
    height: 34px;
    line-height: 34px;
    color: #323233;
    margin-bottom: 4px;
    .colorful-text {
      background: linear-gradient(345deg, #1574ff 2%, #5952ff 51%, #a969fe 96%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
  }

  .hello__desc {
    font-size: 16px;
    font-weight: normal;
    color: #323233;
    height: 22px;
    line-height: 22px;
    text-align: center;
  }
}
</style>
